import useGetProductImagePath from '@/hooks/useGetProductImagePath'
import { isEmpty } from '@/utils/string'
import { cn } from 'oddle-shop-monorepo.design-system'
import ProductDescription from './ProductDescription'
import ProductImageCarousel from './ProductImageCarousel'

export const imageSize = 360

interface ProductImageProps {
  productState: Oms.MenuItem
  showDefaultImage: boolean
  category: Oms.MenuCategory
}

const ProductImage = ({
  productState,
  showDefaultImage,
  category,
}: ProductImageProps): JSX.Element => {
  const { getProductImagePath, getProductImageBlurDataURL } =
    useGetProductImagePath()

  const imageFullUrls =
    productState.imageFullUrls?.filter((image) => !isEmpty(image))?.length > 0
      ? productState.imageFullUrls
      : productState.imageUrls?.filter((image) => !isEmpty(image))?.length > 0
      ? productState.imageUrls
      : [null]
  const allImages = imageFullUrls.map((imageUrl) => ({
    imageUrl: getProductImagePath(imageUrl, showDefaultImage, {
      shouldCache: true,
      containerHeight: 1000,
    }),
    blurDataURL: getProductImageBlurDataURL(imageUrl),
  }))

  const images = typeof window !== 'undefined' ? allImages : [allImages[0]]

  const validImages = images.filter((image) => image?.imageUrl)

  if (validImages.length > 0) {
    return (
      <div>
        <div className="flex flex-col md:flex-row">
          <div
            className={cn(
              'flex-shrink-0 overflow-hidden',
              'h-auto w-screen md:w-[360px]'
            )}
          >
            <div className="relative">
              <ProductImageCarousel
                images={
                  validImages as {
                    imageUrl: string
                    blurDataURL: string | undefined
                  }[]
                }
              />
            </div>
          </div>
          <ProductDescription productState={productState} category={category} />
        </div>
      </div>
    )
  }

  return (
    <ProductDescription
      productState={productState}
      category={category}
      noImage
    />
  )
}

export default ProductImage
